// extracted by mini-css-extract-plugin
module.exports = {"placeholder_line":"EmptyPlaceholder_placeholder_line__1ny01"};